import { cn } from 'cn'

/**
 * Decorative marks from the kiranalabs.com illustration language: the eye
 * lens (it opens wider as a process advances), the white node tile that
 * carries it on a track, and the four-point sparkle that ends a track.
 */

/** How open the lens is for step `index` of `count`: 0.35 at the start, 1 at the end. */
export function lensOpenness(index: number, count: number): number {
  if (count <= 1) return 1
  return 0.35 + (0.65 * index) / (count - 1)
}

export function Lens({ open = 1, className }: { open?: number; className?: string }) {
  const q = 2 + 12 * open
  const r = 2.5 + 2.5 * open
  return (
    <svg
      className={cn('site-lens', className)}
      viewBox="0 0 36 24"
      aria-hidden="true"
      focusable="false"
    >
      <path d={`M2 12 Q18 ${(12 - q).toFixed(1)} 34 12 Q18 ${(12 + q).toFixed(1)} 2 12 Z`} />
      <circle cx="18" cy="12" r={r.toFixed(1)} />
    </svg>
  )
}

/** The tile a step sits on: white with an opening lens; the last step is the blue tile. */
export function StepNode({ index, count }: { index: number; count: number }) {
  return (
    <span
      className={cn('site-step-node', index === count - 1 && 'site-step-node--final')}
      aria-hidden="true"
    >
      <Lens open={lensOpenness(index, count)} />
    </span>
  )
}

export function Sparkle({ className }: { className?: string }) {
  return (
    <svg
      className={cn('site-sparkle', className)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 0C12.9 7.6 16.4 11.1 24 12C16.4 12.9 12.9 16.4 12 24C11.1 16.4 7.6 12.9 0 12C7.6 11.1 11.1 7.6 12 0Z" />
    </svg>
  )
}
